import axios from 'axios';
import {EventBus} from "./eventbus";
import router from './router'


export const HTTP = axios.create({
    timeout: 60000
});

HTTP.defaults.headers.Authorization = 'Bearer ' + localStorage.ridtoken;
HTTP.defaults.baseURL = localStorage.baseUrl;

HTTP.interceptors.response.use((response) => {
    // do something with the response data
    console.log('Response was received');

    return response;
}, error => {
    console.log("error");
    if (error.response == null) {
        EventBus.$emit('error', error.toString());
    } else if (error.response.status === 401) {
        localStorage.removeItem("token");
        router.push("/login").then(r => console.log(r));
    } else {
        EventBus.$emit('error', error.toString());
    }

    return Promise.reject(error);
});